import React, { useState, useEffect } from 'react';
import './Userprofile.css'
import TitleNames from '../../Component/Header/TitleNames'
import { Link, useNavigate, useParams } from "react-router-dom";
import { PostAPI, GetAPI } from '../../common/Api';
import moment from 'moment';
const Userprofile = () => {
  const navigate = useNavigate();
  const { mainuserprofile } = useParams()


  const counsellor_id = JSON.parse(sessionStorage.getItem('login_details')).counsellor_id;

  const [Uniqueuserprofile, setUniqueuserprofile] = useState([])
  const [Uniqueuserprofiler, setUniqueuserprofiler] = useState([])
  console.log('dddddddddddddddddd',Uniqueuserprofile)
  console.log('dddddddddddddddddd',Uniqueuserprofiler)
  useEffect(() => {
    let formData = new FormData();
    formData.append('counsellor_id', counsellor_id);
    formData.append('user_id', mainuserprofile);
    var apiData = {
      url: 'al_user_details',
      data: formData
    }

    PostAPI(apiData, (res) => {
      if (res && res.status) {
        setUniqueuserprofile(res?.user_data)
        setUniqueuserprofiler(res?.user_details)
        console.log("hg", res?.data)
      }
    })
  }, [])
  return (
    <>
      <div><TitleNames /></div>
      <div className='UserProfileMainContent'>
        <div className="container-fluid">
          <div><h5 className='UserProfileHeadTitlen'>User Profile</h5></div>

          <div className='row'>
            <div className='col-lg-6 ContentColUser'>
             
              <div className='UserProfileDetailsContent'>
                <p className='UserProfileNameTitile'>User Id </p>
                <span className='DotspaceUserProfile'>:</span>
                <p className='UserProfileValue'>{Uniqueuserprofile[0]?.id}</p>
              </div>
              <div className='UserProfileDetailsContent'>
                <p className='UserProfileNameTitile'>Name </p>
                <span className='DotspaceUserProfile'>:</span>
                <p className='UserProfileValue'>{Uniqueuserprofile[0]?.user_name}
                </p>

              </div>
              <div className='UserProfileDetailsContent'>
                <p className='UserProfileNameTitile'>Mobile </p>
                <span className='DotspaceUserProfile'>:</span>
                <p className='UserProfileValue'>{Uniqueuserprofile[0]?.user_phone}
                </p>

              </div>
              <div className='UserProfileDetailsContent'>
                <p className='UserProfileNameTitile'>Email </p>
                <span className='DotspaceUserProfile'>:</span>
                <p itemType='email' className='UserProfileValue'>{Uniqueuserprofile[0]?.email}
                </p>

              </div>
              <div className='UserProfileDetailsContent'>
                <p className='UserProfileNameTitile'>Last Activity </p>
                <span className='DotspaceUserProfile'>:</span>
                <p className='UserProfileValue'>{Uniqueuserprofile[0]?.last_activity}
                </p>

              </div>
              <div className='UserProfileDetailsContent'>
                <p className='UserProfileNameTitile'>DOB </p>
                <span className='DotspaceUserProfile'>:</span>
                <p className='UserProfileValue'>{Uniqueuserprofile[0]?.user_dob}
                </p>

              </div>
              <div className='UserProfileDetailsContent'>
                <p className='UserProfileNameTitile'>State </p>
                <span className='DotspaceUserProfile'>:</span>
                <p className='UserProfileValue'>{Uniqueuserprofile[0]?.user_state}
                </p>

              </div>
              <div className='UserProfileDetailsContent'>
                <p className='UserProfileNameTitile'>City </p>
                <span className='DotspaceUserProfile'>:</span>
                <p className='UserProfileValue'>{Uniqueuserprofile[0]?.user_city}
                </p>

              </div>
              <div className='UserProfileDetailsContent'>
                <p className='UserProfileNameTitile'>Relationship </p>
                <span className='DotspaceUserProfile'>:</span>
                <p className='UserProfileValue'>{Uniqueuserprofile[0]?.user_phone}
                </p>

              </div>
              <div className='UserProfileDetailsContent'>
                <p className='UserProfileNameTitile'>User Mode </p>
                <span className='DotspaceUserProfile'>:</span>
                <p className='UserProfileValue'>{Uniqueuserprofile[0]?.user_mode}
                </p>

              </div>

            </div>
            <div className='col-lg-6 ContentColUser'>
              <div id="div1" className='UserProfilesProblems'>
                <div id="div2" className='UserProfilesProblemsInner' >
                  <div id="div3" className='UserProblemsMain' >
                    {/* <div><p>Concern</p></div> */}
                    <div className='QueryDetailsContentv'> <p className='UserNameQuery NameQuery'>Allergies </p> <span className='Dotspace'>:</span> <p className='NameQuery'>{(Uniqueuserprofiler[0]?.allergies == 0)?"No":"Yes"}</p> </div>
                   
                    <div className='QueryDetailsContentv'> <p className='UserNameQuery NameQuery'>Pcos pcod</p>  <span className='Dotspace'>:</span><p className='NameQuery'>{(Uniqueuserprofiler[0]?.pcos_pcod == 0)?"No":"Yes"}</p>  </div>
                    <div className='QueryDetailsContentv'> <p className='UserNameQuery NameQuery'> Dysmennorhoea</p> <span className='Dotspace'>:</span> <p className='NameQuery'>{(Uniqueuserprofiler[0]?.dysmennorhoea == 0)?"No":"Yes"}</p></div>
                    
                    <div className='QueryDetailsContentv'>  <p className='UserNameQuery NameQuery'>Endometriosis</p> <span className='Dotspace'>:</span> <p className='NameQuery'>  {(Uniqueuserprofiler[0]?.endometriosis == 0)?"No":"Yes"}</p></div>
                    <div className='QueryDetailsContentv'>  <p className='UserNameQuery NameQuery'>Thyroid</p> <span className='Dotspace'>:</span> <p className='NameQuery'> {(Uniqueuserprofiler[0]?.thyroid == 0)?"No":"Yes"}</p></div>
                    <div className='QueryDetailsContentv'>  <p className='UserNameQuery NameQuery'>Mental Health </p> <span className='Dotspace'>:</span> <p className='NameQuery'> {(Uniqueuserprofiler[0]?.mental_health == 0)?"No":"Yes"}</p></div>
                    <div className='QueryDetailsContentv'>  <p className='UserNameQuery NameQuery'>User medication</p> <span className='Dotspace'>:</span> <p className='NameQuery'> {(Uniqueuserprofiler[0]?.user_medication == 0)?"No":"Yes"}</p></div>
                    <div className='QueryDetailsContentv'>  <p className='UserNameQuery NameQuery'>Education</p> <span className='Dotspace'>:</span> <p className='NameQuery'> {(Uniqueuserprofiler[0]?.user_education == 0)?"No":"Yes"}</p></div>
                    <div className='QueryDetailsContentv'>  <p className='UserNameQuery NameQuery'>Employment</p> <span className='Dotspace'>:</span> <p className='NameQuery'> {(Uniqueuserprofiler[0]?.employment == 0)?"No":"Yes"}</p></div>
                    <div className='QueryDetailsContentv'>  <p className='UserNameQuery NameQuery'>Sexually Active </p> <span className='Dotspace'>:</span> <p className='NameQuery'> {(Uniqueuserprofiler[0]?.sexually_active == 0)?"No":"Yes"}</p></div>

                    <div className='QueryDetailsContentv'>  <p className='UserNameQuery NameQuery'>Married Status</p> <span className='Dotspace'>:</span> <p className='NameQuery'>{(Uniqueuserprofiler[0]?.married_status == 0)?"No":"Yes"}</p></div>
                    <div className='QueryDetailsContentv'>  <p className='UserNameQuery NameQuery'>Children</p> <span className='Dotspace'>:</span> <p className='NameQuery'> {(Uniqueuserprofiler[0]?.children == 0)?"No":"Yes"}</p></div>
                    <div className='QueryDetailsContentv'>  <p className='UserNameQuery NameQuery'>Weight</p> <span className='Dotspace'>:</span> <p className='NameQuery'> {(Uniqueuserprofiler[0]?.user_weight == 0)?"No":"Yes"}</p></div>
                    <div className='QueryDetailsContentv'>  <p className='UserNameQuery NameQuery'>Height</p> <span className='Dotspace'>:</span> <p className='NameQuery'> {(Uniqueuserprofiler[0]?.user_height == 0)?"No":"Yes"}</p></div>
                    <div className='QueryDetailsContentv'>  <p className='UserNameQuery NameQuery'>Blood group</p> <span className='Dotspace'>:</span> <p className='NameQuery'> {(Uniqueuserprofiler[0]?.user_blood_group == 0)?"No":"Yes"}</p></div>
                    <div className='QueryDetailsContentv'>  <p className='UserNameQuery NameQuery'>Diabetics</p> <span className='Dotspace'>:</span> <p className='NameQuery'>{(Uniqueuserprofiler[0]?.user_diabetics == 0)?"No":"Yes"}</p></div>
                    <div className='QueryDetailsContentv'>  <p className='UserNameQuery NameQuery'>Hypertension</p> <span className='Dotspace'>:</span> <p className='NameQuery'> {(Uniqueuserprofiler[0]?.user_hypertension == 0)?"No":"Yes"}</p></div>
                    <div className='QueryDetailsContentv'>  <p className='UserNameQuery NameQuery'>Heart Problem </p> <span className='Dotspace'>:</span> <p className='NameQuery'> {(Uniqueuserprofiler[0]?.user_heart_pblm == 0)?"No":"Yes"}</p></div>
                    <div className='QueryDetailsContentv'>  <p className='UserNameQuery NameQuery'>Asthma</p> <span className='Dotspace'>:</span> <p className='NameQuery'> {(Uniqueuserprofiler[0]?.user_ashtma == 0)?"No":"Yes"}</p></div>
                    <div className='QueryDetailsContentv'>  <p className='UserNameQuery NameQuery'>Contraceptives</p> <span className='Dotspace'>:</span> <p className='NameQuery'>{(Uniqueuserprofiler[0]?.contraceptives == 0)?"No":"Yes"}</p></div>
                    <div className='QueryDetailsContentv'>  <p className='UserNameQuery NameQuery'>pills reminder</p> <span className='Dotspace'>:</span> <p className='NameQuery'>{(Uniqueuserprofiler[0]?.pills_reminder == 0)?"No":"Yes"}</p></div>
                    <div className='QueryDetailsContentv'>  <p className='UserNameQuery NameQuery'>purpose_using_app </p> <span className='Dotspace'>:</span> <p className='NameQuery'>{(Uniqueuserprofiler[0]?.purpose_using_app == 0)?"No":"Yes"}</p></div>
                    <div className='QueryDetailsContentv'>  <p className='UserNameQuery NameQuery'>user_details_updated </p> <span className='Dotspace'>:</span> <p className='NameQuery'> {(Uniqueuserprofiler[0]?.user_details_updated == 0)?"No":"Yes"}</p></div>




                   
                   
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  )
}

export default Userprofile